import React, { Component, Fragment } from 'react'
import Popover from 'react-popover'
import ActivityPopover from './ActivityPopover'
import './styles.scss'

const baseClass = 'company-dashboard-top-section-top'

class TopSection extends Component {
  state = {
    isOpen: false,
    width: null,
  }

  togglePopover = () => this.setState(({ isOpen }) => ({ isOpen: !isOpen }))

  renderActivitySection(activity) {
    return (
      <Fragment>
        <ActivityPopover activity={activity} />
      </Fragment>
    )
  }

  render() {
    const { width, title, showModal, activity } = this.props
    const { isOpen } = this.state

    return (
      <div className={`${baseClass}`}>
        <div className={`${baseClass}__title`}>{title}:</div>
        {width < 570 ? (
          <p
            className={`${baseClass}__tooltip`}
            onClick={() => showModal(ActivityPopover, { activity, isModal: true })}
          >
            {activity.name}
          </p>
        ) : (
          <Popover
            isOpen={isOpen}
            preferPlace="below"
            place="below"
            onOuterAction={this.togglePopover}
            body={this.renderActivitySection(activity)}
          >
            <p className={`${baseClass}__tooltip`} onClick={this.togglePopover}>
              {activity.name}
            </p>
          </Popover>
        )}
        <p className={`${baseClass}__sub`}>{activity.proTrackName}</p>
      </div>
    )
  }
}

export default TopSection
